import PropTypes from 'prop-types';

import { TOP, BOTTOM, LEFT, RIGHT, START, END, CENTER } from './constants';

export const eitherOrPropType =
  (firstProp, secondProp, propType, isRequired = false) =>
  (props, propName, componentName) => {
    const hasFirstProp = props[firstProp];
    const hasSecondProp = props[secondProp];
    /* eslint-disable max-len */
    if (hasFirstProp && hasSecondProp) {
      return new Error(`You can provide either '${firstProp}' or '${secondProp}' to '${componentName}' but not both.`);
    }
    if (isRequired && !hasFirstProp && !hasSecondProp) {
      return new Error(
        `You must provide either '${firstProp}' or '${secondProp}' to '${componentName}' (but not both).`,
      );
    }
    /* eslint-enable max-len */

    return PropTypes.checkPropTypes({ [propName]: propType }, props, propName, componentName);
  };

export const childrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);

export const childrenRenderPropType = PropTypes.func;

export const componentsPropType = PropTypes.oneOfType([PropTypes.element, PropTypes.func]);

export const localePropType = (isRequired) => (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment
  const prop = props[propName];
  if (isRequired && (!prop || !prop.length)) {
    return new Error(
      `Prop \`${propName}\` is marked as required in \`${componentName}\`,` + `but received \`${prop}\`.`,
    );
  }

  if (!/[a-z]{2}-[A-Z]{2}/.test(prop)) {
    return new Error(`Invalid prop \`${propName}\` supplied to` + ` \`${componentName}\`. Validation failed.`);
  }

  return null;
};

export const positionPropType = PropTypes.oneOf([TOP, BOTTOM, LEFT, RIGHT]);
export const alignPropType = PropTypes.oneOf([START, END, CENTER]);
